import { prop } from '@ipfabric/utils/fp/prop';
import { selectOriginalTopologyPreset } from 'components/Graph/GraphSidePanel/selectors/selectOriginalTopologyPreset';
import type { GraphState } from 'components/Graph/GraphState';
import deepEqual from 'react-fast-compare';
import { createSelector } from 'reselect';
import { createScopedSelector } from 'utils/react/scopedSelector';

export const selectTopologyPresetModified: (s: GraphState) => boolean =
  createScopedSelector(() =>
    createSelector(
      prop('layoutSettings', 'presetDraft'),
      selectOriginalTopologyPreset,
      (presetDraft, originalPreset) => !deepEqual(originalPreset, presetDraft),
    ),
  );
